@if (updatedDetailCache?.length > 0) {
  @for (missed of updatedDetailCache; track missed) {
    <div class="reason">
      @if (showReason) {
        <div class="add-reason" invalid="false">
          @if (reasonItems === undefined) {
            <span (click)="shoCommentsMenu()">
              <i class="material-icons">add_circle_outline</i> Add Reason
            </span>
          }
          <div reason-menu [attr.show]="isCommentMenu">
            @for (items of addReasonItems; track items; let i = $index) {
              <div reason-menu-item>
                <mat-checkbox color="primary" (change)="insertReason(items,missed.id,$event);" name="commentCheckboxes" [checked]="items.selected">
                  {{items.label}}
                </mat-checkbox>
                @if (items.label === 'Other') {
                  <mat-form-field>
                    <input type="text" [disabled]="isOther" matInput [(ngModel)]="otherCommentText" (focusout)="mouseleave('updateTime')">
                  </mat-form-field>
                }
              </div>
            }
          </div>
          @if (reasonItems !== undefined) {
            <div class="chip">{{reasonItems}}
              <i class="material-icons" (click)="removeReason('update')">cancel</i>
            </div>
          }
        </div>
      }
    </div>
  }
} @else {
  @if (isAdded) {
    <div class="reason">
      @if (listText) {
        <div class="title">
          <p>{{listText}} :
            <span> {{this.newAddedDetails.checkInTime | dateFormat :'rosterTime'}}-{{
              this.newAddedDetails.checkOutTime | dateFormat :'rosterTime'}}(
            {{getTimeDiff(this.newAddedDetails.checkInTime,this.newAddedDetails.checkOutTime)}}) </span>
          </p>
        </div>
      }
      @if (showReason) {
        <div class="add-reason" invalid="false">
          @if (addnewReasonItems === undefined && !listText) {
            <span (click)="shoCommentsMenu()">
              <i class="material-icons">add_circle_outline</i> Add Reason
            </span>
          }
          <div reason-menu [attr.show]="isCommentMenu">
            @for (items of addReasonItems; track items; let i = $index) {
              <div reason-menu-item>
                <mat-checkbox color="primary" (change)="insertReason(items,0,$event);" name="commentCheckboxes" [checked]="items.selected">
                  {{items.label}}
                </mat-checkbox>
                @if (items.label === 'Other') {
                  <mat-form-field>
                    <input type="text" [disabled]="isOther" matInput [(ngModel)]="otherCommentText" (mouseleave)="mouseleave('addTime')">
                  </mat-form-field>
                }
              </div>
            }
          </div>
          @if (addnewReasonItems !== undefined) {
            <div class="chip">{{addnewReasonItems}}
              <i class="material-icons" (click)="removeReason('add')">cancel</i>
            </div>
          }
        </div>
      }
    </div>
  }
}


<div class="buttons">
  @if (isShowSave) {
    <button type="button" class="btn" [attr.show]="saveBtn" (click)="cancelTimeMissed()">Cancel</button>
  }
  @if (isShowSave) {
    <button type="button" class="btn btn-primary" [attr.show]="saveBtn" (click)="save()">Save Changes</button>
  }
  @if (isSuccess) {
    <button class="btn btn-success-flat">Saved Successfully
      <i class="material-icons" (click)="closeSuccess(i)">check_circle_outline</i>
    </button>
  }
</div>